export enum Status {
    MEASURING = "Measuring",
    NOTMEASURED = "NotMeasured",
    MEASURED = "Measured",
    APPROVED = "Approved",
    REJECTED = "Rejected",
    STOPPED = "Stopped",
    PAUSED = "Paused",
    COMPLETED = "Completed",
    PENDING = "Pending",
    INUSE = "In Use",
    AVAILABLE = "Available",
    WAITING = "Waiting",
    REMEASURE = "Remeasure",
    INPROGRESS = 'In Progress',
}